// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ReportSummary-module__container {
  font-family: Montserrat;
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  gap: 16px;
  angle: 0 deg;
  opacity: 1;
  padding-right: 24px;
  padding-left: 24px;
}
.ReportSummary-module__heading {
  display: flex;
  align-items: center;
  text-align: left;
  width: 100%;
}
.ReportSummary-module__heading p {
  font-weight: 500;
  font-style: Medium;
  font-size: 14px;
  leading-trim: NONE;
  line-height: 20px;
  letter-spacing: -0.15px;
  color: #717182;
}
.ReportSummary-module__marksGrid {
  display: grid;
  grid-template-columns: repeat(10, minmax(0, 1fr));
  gap: 8px;
}
.ReportSummary-module__marksCard {
  width: 100%;
  height: 54px;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  angle: 0 deg;
  opacity: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.ReportSummary-module__marksCard span {
  font-weight: 400;
  font-style: Regular;
  font-size: 12px;
  leading-trim: NONE;
  line-height: 16px;
  letter-spacing: 0px;
  color: #717182;
}
.ReportSummary-module__marks span {
  font-weight: 400;
  font-style: Regular;
  font-size: 14px;
  leading-trim: NONE;
  line-height: 20px;
  letter-spacing: -0.15px;
  color: #717182;
}
.ReportSummary-module__awardedMarks {
  font-weight: 400;
  font-style: Regular;
  font-size: 14px;
  leading-trim: NONE;
  line-height: 20px;
  letter-spacing: -0.15px;
  color: #155dfc !important;
}
.ReportSummary-module__notEvaluated {
  background-color: #f3f4f6;
  border-top: 1px solid #d1d5dc;
}
.ReportSummary-module__underLine {
  width: 100%;
  height: 1px;
  border: 1px solid #0000001a;
}
.ReportSummary-module__totalMarksContainer {
  display: flex;
  width: 100%;
  height: 72px;
  border-radius: 10px;
  justify-content: space-between;
  angle: 0 deg;
  opacity: 1;
  padding-right: 16px;
  padding-left: 16px;
  background-color: #dbeafe;
}
.ReportSummary-module__totalMarksHeading {
  display: flex;
  flex-direction: column;
  gap: 4px;
  height: 100%;
  justify-content: space-evenly;
}
.ReportSummary-module__totalMarksHeading p {
  font-weight: 600;
  font-style: Semi Bold;
  font-size: 14px;
  leading-trim: NONE;
  line-height: 20px;
  letter-spacing: -0.15px;
  color: #717182;
  margin: 0;
}
.ReportSummary-module__totalMarksHeading span {
  font-weight: 400;
  font-style: Regular;
  font-size: 12px;
  leading-trim: NONE;
  line-height: 16px;
  letter-spacing: 0px;
  color: #717182;
}
.ReportSummary-module__totalMarksValue {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 123px;
  height: 100%;
  angle: 0 deg;
  opacity: 1;
}
.ReportSummary-module__totalMarksValue span {
  font-weight: 400;
  font-style: Regular;
  font-size: 18px;
  leading-trim: NONE;
  line-height: 28px;
  letter-spacing: -0.44px;
  text-align: right;
  color: #717182;
}
.ReportSummary-module__totalAwardedMarks {
  font-size: 24px !important;
  color: #1c398e !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/reportsummary/ReportSummary.module.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,aAAa;EACb,iDAAiD;EACjD,QAAQ;AACV;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;EACvB,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;AACA;EACE,WAAW;EACX,WAAW;EACX,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,6BAA6B;AAC/B;AACA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;EACd,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B","sourcesContent":[".container {\n  font-family: Montserrat;\n  width: 100%;\n  height: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  angle: 0 deg;\n  opacity: 1;\n  padding-right: 24px;\n  padding-left: 24px;\n}\n.heading {\n  display: flex;\n  align-items: center;\n  text-align: left;\n  width: 100%;\n}\n.heading p {\n  font-weight: 500;\n  font-style: Medium;\n  font-size: 14px;\n  leading-trim: NONE;\n  line-height: 20px;\n  letter-spacing: -0.15px;\n  color: #717182;\n}\n.marksGrid {\n  display: grid;\n  grid-template-columns: repeat(10, minmax(0, 1fr));\n  gap: 8px;\n}\n.marksCard {\n  width: 100%;\n  height: 54px;\n  border-radius: 8px;\n  border: 1px solid #e5e7eb;\n  angle: 0 deg;\n  opacity: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n.marksCard span {\n  font-weight: 400;\n  font-style: Regular;\n  font-size: 12px;\n  leading-trim: NONE;\n  line-height: 16px;\n  letter-spacing: 0px;\n  color: #717182;\n}\n.marks span {\n  font-weight: 400;\n  font-style: Regular;\n  font-size: 14px;\n  leading-trim: NONE;\n  line-height: 20px;\n  letter-spacing: -0.15px;\n  color: #717182;\n}\n.awardedMarks {\n  font-weight: 400;\n  font-style: Regular;\n  font-size: 14px;\n  leading-trim: NONE;\n  line-height: 20px;\n  letter-spacing: -0.15px;\n  color: #155dfc !important;\n}\n.notEvaluated {\n  background-color: #f3f4f6;\n  border-top: 1px solid #d1d5dc;\n}\n.underLine {\n  width: 100%;\n  height: 1px;\n  border: 1px solid #0000001a;\n}\n.totalMarksContainer {\n  display: flex;\n  width: 100%;\n  height: 72px;\n  border-radius: 10px;\n  justify-content: space-between;\n  angle: 0 deg;\n  opacity: 1;\n  padding-right: 16px;\n  padding-left: 16px;\n  background-color: #dbeafe;\n}\n.totalMarksHeading {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  height: 100%;\n  justify-content: space-evenly;\n}\n.totalMarksHeading p {\n  font-weight: 600;\n  font-style: Semi Bold;\n  font-size: 14px;\n  leading-trim: NONE;\n  line-height: 20px;\n  letter-spacing: -0.15px;\n  color: #717182;\n  margin: 0;\n}\n.totalMarksHeading span {\n  font-weight: 400;\n  font-style: Regular;\n  font-size: 12px;\n  leading-trim: NONE;\n  line-height: 16px;\n  letter-spacing: 0px;\n  color: #717182;\n}\n.totalMarksValue {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  width: 123px;\n  height: 100%;\n  angle: 0 deg;\n  opacity: 1;\n}\n.totalMarksValue span {\n  font-weight: 400;\n  font-style: Regular;\n  font-size: 18px;\n  leading-trim: NONE;\n  line-height: 28px;\n  letter-spacing: -0.44px;\n  text-align: right;\n  color: #717182;\n}\n.totalAwardedMarks {\n  font-size: 24px !important;\n  color: #1c398e !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ReportSummary-module__container`,
	"heading": `ReportSummary-module__heading`,
	"marksGrid": `ReportSummary-module__marksGrid`,
	"marksCard": `ReportSummary-module__marksCard`,
	"marks": `ReportSummary-module__marks`,
	"awardedMarks": `ReportSummary-module__awardedMarks`,
	"notEvaluated": `ReportSummary-module__notEvaluated`,
	"underLine": `ReportSummary-module__underLine`,
	"totalMarksContainer": `ReportSummary-module__totalMarksContainer`,
	"totalMarksHeading": `ReportSummary-module__totalMarksHeading`,
	"totalMarksValue": `ReportSummary-module__totalMarksValue`,
	"totalAwardedMarks": `ReportSummary-module__totalAwardedMarks`
};
export default ___CSS_LOADER_EXPORT___;
